export const OPENING_SENTENCES: {
    [id: string]: { text: string; ref: string }[];
} = {
    "1662": [
        {
            text: "When the wicked man turneth away from his wickedness that he hath committed, and doeth that which is lawful and right, he shall save his soul alive.",
            ref: "Ezekiel 18:27",
        },
        {
            text: "I acknowledge my transgressions, and my sin is ever before me.",
            ref: "Psalm 51:3",
        },
        {
            text: "Hide thy face from my sins, and blot out all mine iniquities.",
            ref: "Psalm 51:9",
        },
        {
            text: "The sacrifices of God are a broken spirit: a broken and a contrite heart, O God, thou wilt not despise.",
            ref: "Psalm 51:17",
        },
        {
            text: "Rend your heart, and not your garments, and turn unto the Lord your God: for he is gracious and merciful, slow to anger, and of great kindness, and repenteth him of the evil.",
            ref: "Joel 2:13",
        },
        {
            text: "To the Lord our God belong mercies and forgivenesses, though we have rebelled against him: neither have we obeyed the voice of the Lord our God, to walk in his laws which he set before us.",
            ref: "Daniel 9:9",
        },
        {
            text: "O Lord, correct me, but with judgement; not in thine anger, lest thou bring me to nothing.",
            ref: "Jeremiah 10:24",
        },
        {
            text: "Repent ye; for the Kingdom of heaven is at hand.",
            ref: "St. Matthew 3:2",
        },
        {
            text: "I will arise and go to my father, and will say unto him, Father, I have sinned against heaven, and before thee, and am no more worthy to be called thy son.",
            ref: "St. Luke 15:18-19",
        },
        {
            text: "Enter not into judgement with thy servant, O Lord; for in thy sight shall no man living be justified.",
            ref: "Psalm 143:2",
        },
        {
            text: "If we say that we have no sin, we deceive ourselves, and the truth is not in us: but if we confess our sins, he is faithful and just to forgive us our sins, and to cleanse us from all unrighteousness.",
            ref: "1 St. John 1:8-9",
        },
    ],
    advent: [
        {
            text: "I shall see him, but not now. I shall behold him, but not now. There shall come a Star out of Jacob, and a Scepter shall rise out of Israel.",
            ref: "Numbers 24:17",
        },
        {
            text: "The Lord shall judge the ends of the earth, and he shall give strength unto his king, and exalt the horn of his Anointed.",
            ref: "1 Samuel 2:10",
        },
        {
            text: "Prepare ye the way of the Lord; make straight in the desert a highway for our God.",
            ref: "Isaiah 40:3",
        },
        {
            text: "And the glory of the Lord shall be revealed, and all flesh shall see it together.",
            ref: "Isaiah 40:5",
        },
        {
            text: "Behold, the days come, saith the Lord, that I will raise unto David a righteous Branch, and a King shall reign and prosper, and shall execute judgment and justice in the earth.",
            ref: "Jeremiah 23:5",
        },
        {
            text: "Repent ye, for the kingdom of heaven is at hand.",
            ref: "Matthew 3:2",
        },
        {
            text: "The time is fulfilled, and the kingdom of heaven is at hand. Repent ye, and believe the Gospel.",
            ref: "Mark 1:15",
        },
        {
            text: "Jesus said, The powers that are in Heaven shall be shaken. And then shall they see the Son of man coming in the clouds, with great power and glory.",
            ref: "Mark 13:25",
        },
        {
            text: "Watch ye, for ye know not when the master of the house cometh — at even, or at midnight, or at the cock crowing, or in the morning — lest coming suddenly, he find you asleep.",
            ref: "Mark 13:35",
        },
        {
            text: "The night is far spent, the day is at hand: let us therefore cast off the works of darkness, and let us put on the armour of light.",
            ref: "Romans 13:12",
        },
        {
            text: "If they escaped not who refused him that spake on earth, much more shall we not escape if we turn away from him that speaketh from Heaven.",
            ref: "Hebrews 12:25",
        },
        {
            text: "If thou shalt not watch, I will come on thee as a thief, and thou shalt not know at what hour I will come upon thee.",
            ref: "Revelation 3:3",
        },
        {
            text: "Behold, I come quickly, hold that fast which thou hast, that no man take thy crown.",
            ref: "Revelation 3:11",
        },
        {
            text: "Behold, I come quickly, and my reward is with me, to give every man according as his work shall be.",
            ref: "Revelation 22:12",
        },
    ],
    christmas: [
        {
            text: "Mary shall bring forth a son, and thou shalt call his name Jesus, for he shall save his people from their sins.",
            ref: "Matthew 1:21",
        },
        {
            text: "Mary brought forth her first-born Son, and wrapped him in swaddling clothes, and laid him in a manger, because there was no room for them in the inn.",
            ref: "Luke 2:7",
        },
        {
            text: "Behold, I bring you good tidings of great joy, which shall be to all people. For unto you is born this day in the city of David a Saviour, which is Christ the Lord.",
            ref: "Luke 2:10",
        },
        {
            text: "Behold, the tabernacle of God is with men, and he will dwell with them, and they shall be his people, and God himself shall be with them, and be their God.",
            ref: "Revelation 21:3",
        },
        {
            text: "The Word was made flesh, and dwelt among us, and we beheld his glory, the glory as of the only-begotten of the Father, full of grace and truth.",
            ref: "John 1:14",
        },
    ],
    epiphany: [
        {
            text: "Arise, shine; for thy light has come, and the glory of the Lord is risen upon thee.",
            ref: "Isaiah 51:1",
        },
        {
            text: "All they from Sheba shall come; they shall bring gold and incense; and they shall show forth the praises of the Lord.",
            ref: "Isaiah 60:6",
        },
        {
            text: "Awake, awake, put on thy strength O Sion, put on thy beautiful garments, O Jerusalem the holy city.",
            ref: "Isaiah 52:1",
        },
        {
            text: "I will give thee for a light to the Gentiles, that thou mayest be my salvation, unto the end of the earth.",
            ref: "Isaiah 49:6",
        },
        {
            text: "The Gentiles shall come to thy light, and kings to the brightness of thy rising.",
            ref: "Isaiah 63:3",
        },
        {
            text: "From the rising of the sun even unto the going down of the same my Name shall be great among the Gentiles; and in every place incense shall be offered unto my Name, and a pure offering: for my Name shall be great among the heathen, saith the LORD of hosts.",
            ref: "Malachi 1:11",
        },
        {
            text: "Lo, the star which the wise men saw in the East went before them, till it came and stood over where the young Child was.",
            ref: "Matthew 2:9",
        },
        {
            text: "When the wise men saw the star, they rejoiced with exceeding great joy. And when they were coming into the house, they saw the young Child with Mary his Mother, and fell down, and worshipped him.",
            ref: "Matthew 2:10",
        },
        {
            text: "John the Baptist said, I have need to be baptised of thee, and comest thou to me? And Jesus answering said unto him, Suffer it to be so now: for thus it becometh us to fulfill all righteousness.",
            ref: "Matthew 3:14-15",
        },
        {
            text: "Jesus came from Nazareth of Galilee, and was baptised of John in the Jordan. And there came a voice from Heaven saying, Thou art my beloved Son, in whom I am well pleased.",
            ref: "Mark 1:9-11",
        },
        {
            text: "John the Baptist said, He that sent me to baptise with water, the same said unto me, Upon whom thou shalt see the Spirit descending, and remaining on him, the same is he which baptiseth with the Holy Ghost. And I saw, and bare record, that this is the Son of God.",
            ref: "John 1:33,34",
        },
    ],
    lent: [
        {
            text: "Moses said, fear not: for God is come to prove you, and that his fear may be before your faces, that ye sin not.",
            ref: "Exodus 20:20",
        },
        {
            text: "I acknowledge my transgressions, and my sin is ever before me.",
            ref: "Psalm 51:3",
        },
        {
            text: "The sacrifice of God is a troubled spirit; a broken and contrite heart, O God, shalt thou not despise.",
            ref: "Psalm 51:7",
        },
        {
            text: "Let the wicked forsake his way, and the unrighteous man his thoughts, and let him return unto the Lord, and he will have mercy upon him; and to our God, for he will abundantly pardon.",
            ref: "Isaiah 55:7",
        },
        {
            text: "Cry aloud, spare not, lift up thy voice like a trumpet, and show my people their transgression, and the house of Jacob their sin.",
            ref: "Isaiah 58:1",
        },
        {
            text: "To the Lord our God belong mercies and forgivenesses, though we have rebelled against him; neither have we obeyed the voice of the LORD our God, to walk in his laws which he set before us.",
            ref: "Daniel 9:9-10",
        },
        {
            text: "Rend your heart, and not your garments, and turn unto the LORD your God: for he is gracious and merciful, slow to anger, and of great kindness.",
            ref: "Joel 2:13",
        },
        {
            text: "Let the priests, the ministers of the Lord, weep between the porch and the altar, and let them say, Spare thy people, O Lord, and give not thine heritage to reproach, that the heathen should rule over them.",
            ref: "Joel 2:17",
        },
        {
            text: "Why do the disiples of John, and of the Pharisees fast, but thy disciples fast not? And Jesus said, The days will come, when the Bridegroom shall be taken away from them, and then shall they fast in those days.",
            ref: "Mark 2:18-20",
        },
        {
            text: "Jesus said, Whosoever will come after me, let him deny himself, and take up his cross, and follow me.",
            ref: "Mark 8:34",
        },
        {
            text: "I will arise and go to my Father, and will say unto him, Father, I have sinned against heaven, and before thee, and am no more worthy to be called thy son.",
            ref: "Luke 15:18-19",
        },
        {
            text: "We ourselves also were sometimes foolish, disobedient, deceived, serving diverse lusts and pleasures, living in malice and envy, hateful, and hating one another. But after the kindness and love of God our Saviour toward man appeared, he saved us.",
            ref: "Titus 3:3-5",
        },
        {
            text: "Let us lay aside every weight, and the sin which doth so easily beset us, and let us run with patience unto the race that is set before us. Looking unto Jesus, the Author and Finisher of our faith.",
            ref: "Hebrews 12:1-2",
        },
        {
            text: "Pure religion and undefiled before God the Father is this, To visit the fatherless and widows in their affliction, and to keep himself unspotted from the world.",
            ref: "James 1:27",
        },
        {
            text: "Dearly beloved: I beseech you as strangers and pilgrims, abstain from fleshly lusts, which war against the soul.",
            ref: "1 Peter 2:11",
        },
        {
            text: "If we say we have no sin, we deceive ourselves, and the truth is not in us; but if we confess our sins, God is faithful and just to forgive us our sins, and to cleanse us from all unrighteousness.",
            ref: "1 John 1:8-9",
        },
        {
            text: "Jesus said, Be watchful, and strengthen the things which remain, that are ready to die: for I have not found thy works perfect before God.",
            ref: "Revelation 3:2",
        },
        {
            text: "Jesus said, Remember how thou hast received and heard, and hold fast, and repent.",
            ref: "Revelation 3:3",
        },
        {
            text: "The dragon was wroth with the woman, and went to make war with the remnant of her seed, which keep the commandments of God, and have the testimony of Jesus Christ.",
            ref: "Revelation 12:17",
        },
        {
            text: "Babylon the great is fallen, is fallen. Come out of her, my people, that ye be not partakers of her sins, and that ye receive not of her plagues: for her sins have reached unto Heaven, and God hath remembered her iniquities.",
            ref: "Revelation 18:2,4-5",
        },
        {
            text: "Jesus said, The fearful, and unbelieving, and the abominable, and murderers, and whoremongers, and sorcerers, and idolators, and all liars, shall have their part in the lake which burneth with fire and brimstone.",
            ref: "Revelation 21:8",
        },
    ],
    passiontide: [
        {
            text: "I gave my back to the smiters, and my cheeks to them that plucked off the hair: I hid not my face from shame and spitting.",
            ref: "Isaiah 50:6",
        },
        {
            text: "He is despised and rejected of men; a Man of sorrows, and acquainted with grief. Surely he hath borne our griefs, and carried our sorrows.",
            ref: "Isaiah 53:3-4",
        },
        {
            text: "He was wounded for our transgressions, he was bruised for our iniquities: the chastisement of our peace was upon him, and with his stripes we are healed.",
            ref: "Isaiah 53:5",
        },
        {
            text: "All we like sheep have gone astray; we have turned every one to his own way; and the Lord hath laid on him the iniquity of us all.",
            ref: "Isaiah 53:6",
        },
        {
            text: "He hath poured out his soul unto death: and he was numbered with the transgressors, and he bare the sins of many, and made intercession for the transgressors.",
            ref: "Isaiah 53:12",
        },
        {
            text: "O Lord, the hope of Israel, all that forsake thee shall be ashamed, and they that depart from thee shall be written in the earth, because they have forsaken the Lord, the Fountain of living waters.",
            ref: "Jeremiah 17:13",
        },
        {
            text: "Is it nothing to you, all ye that pass by? Behold, and see if there be any sorrow like unto my sorrow which is done unto me, wherewith the Lord hath afflicted me.",
            ref: "Lamentations 1:12",
        },
        {
            text: "In Christ we have redemption though his blood, the forgiveness of sins, according to the riches of his grace.",
            ref: "Ephesians 1:7",
        },
        {
            text: "He humbled himself, and became obedient unto death, even the death of the Cross. Wherefore God hath highly exalted him, and given him a Name which is above every name.",
            ref: "Philippians 2:8",
        },
        {
            text: "Let us run with patience unto the race that is set before us. Looking unto Jesus, the Author and Finisher of our faith, who for the joy that was set before him, endured the Cross, despising the shame.",
            ref: "Hebrews 12:1-2",
        },
        {
            text: "Worthy is the Lamb who was slain, to receive power, and riches, and wisdom, and strength, and honor, and glory, and blessing.",
            ref: "Revelation 5:12",
        },
    ],
    easter: [
        {
            text: "This is the day that the LORD hath made; we will rejoice and be glad in it.",
            ref: "Psalm 118:24",
        },
        {
            text: "The LORD of hosts will swallow up death in victory, and the Lord God will wipe away tears from off all faces.",
            ref: "Isaiah 25:8",
        },
        {
            text: "Ye seek Jesus of Nazareth, which was crucified: he is risen, he is not here: behold the place where they laid him.",
            ref: "Mark 16:6",
        },
        {
            text: "He is risen. The Lord is risen indeed.",
            ref: "Luke 24:34",
        },
        {
            text: "Jesus said unto Martha, I am the Resurrection, and the Life: he that believeth in me, though he were dead, yet shall he live. And whosoever liveth and believeth in me, shall never die.",
            ref: "John 11:24",
        },
        {
            text: "Jesus said unto Thomas, Reach hither thy finger, and behold my hands, and reach hither thy hand, and thrust it into my side, and be not faithless, but believing. And Thomas answered, and said unto him, My Lord, and my God.",
            ref: "John 20:27-28",
        },
        {
            text: "Jesus of Nazareth they slew and hanged on a tree. Him God raised up the third day, and showed him openly.",
            ref: "Acts 10:39-40",
        },
        {
            text: "Christ being raised from the dead dieth no more; death hath no dominion over him. For in that he died, he died unto sin once; but in that he liveth, he liveth unto God.",
            ref: "Romans 6:9",
        },
        {
            text: "If in this life only we have hope in Christ, we are of all men most miserable. But now is Christ risen from the dead, and become the first fruits of them that slept.",
            ref: "1 Corinthians 15:19-20",
        },
        {
            text: "For since by man came death, by man came also the resurrection of the dead. For as in Adam all die, even so in Christ shall all be made alive.",
            ref: "1 Corinthians 15:21-22",
        },
        {
            text: "The trumpet shall sound, and the dead shall be raised incorruptible, and we shall be changed.",
            ref: "1 Corinthians 15:52",
        },
        {
            text: "Whatsoever is born of God overcometh the world: and this is the victory that overcometh the world, even our Faith.",
            ref: "1 John 5:4",
        },
        {
            text: "Jesus said, Fear not, I am the first and the last. I am he that liveth, and was dead: and behold, I am alive for evermore.",
            ref: "Revelation 1:17",
        },
        {
            text: "Give thanks unto the LORD, call upon his Name, make known his deeds among the people. Let the heavens be glad, and let the earth rejoice: and let men say among the nations, The LORD reigneth.",
            ref: "1 Chronicles 16:8,31",
        },
        {
            text: "The day is thine, O LORD, and the night is thine; thou hast prepared the light and the sun. Thou hast set all the borders of the earth; thou hast made summer and winter.",
            ref: "Psalm 74:17-18",
        },
        {
            text: "O worship the LORD in the beauty of holiness; let the whole earth stand in awe of him.",
            ref: "Psalm 96:9",
        },
        {
            text: "I was glad when they said unto me, We will go into the house of the LORD.",
            ref: "Psalm 122:1",
        },
        {
            text: "Jesus said, I am the light of the world: he that followeth me, shall not walk in darkness, but shall have the light of life.",
            ref: "John 8:12",
        },
        {
            text: "O the depth of the riches both of the wisdom and knowledge of God! How unsearchable are his judgments, and his ways are past finding out.",
            ref: "Romans 11:33",
        },
    ],
    ascension: [
        {
            text: "Ye men of Galilee, why stand ye gazing up into heaven? This same Jesus, which is taken up from you into heaven, shall so come in like manner as ye have seen him go into heaven.",
            ref: "Acts 1:11",
        },
        {
            text: "If ye then be risen with Christ, seek those things which are above, where Christ sitteth on the right hand of God.",
            ref: "Colossians 3:1",
        },
        {
            text: "Seeing that we have a great High Priest, that is passed into the heavens, Jesus the Son of God, let us come boldly unto the thone of grace, that we may obtain mercy, and find grace to help in time of need.",
            ref: "Hebrews 4:14",
        },
        {
            text: "Christ is not entered into the holy places made with hands, which are the figures of the true, but into Heaven itself, now to appear in the presence of God for us.",
            ref: "Hebrews 9:24",
        },
        {
            text: "Jesus Christ is gone into Heaven, and is on the right hand of God; Angels, and authorities, and powers being made subject unto him.",
            ref: "1 Peter 3:22",
        },
        {
            text: "Behold, a throne was set in Heaven, and one sat on the throne. And he that sat was to look upon like a jasper, and a sardine stone: and there was a rainbow round about the throne, in sight like unto an emerald.",
            ref: "Revelation 4:2",
        },
        {
            text: "Jesus said, To him that overcometh, will I grant to sit with me in my throne, even as I also overcame, and am set down with my Father in his throne.",
            ref: "Revelation 3:21",
        },
        {
            text: "The four and twenty elders fall down before him that sat on the throne, and worship him that liveth for ever and ever, and cast their crowns before the throne.",
            ref: "Revelation 4:10",
        },
    ],
    whitsun: [
        {
            text: "There is a river, the streams whereof make glad the city of God; the holy place of the tabernacle of the Most Highest.",
            ref: "Psalm 46:4",
        },
        {
            text: "Jesus said, If ye love me, keep my commandments. And I will pray the Father, and he shall give you another Comforter, that he may abide with you for ever, even the Spirit of truth.",
            ref: "John 14:15",
        },
        {
            text: "Jesus said, I tell you the truth: it is expedient for you that I go away: for if I go not away, the Comforter will not come unto you: but if I depart, I will send him unto you.",
            ref: "John 16:7",
        },
        {
            text: "Jesus said, When the Spirit of truth is come, he will guide you into all truth. For he shall not speak of himself: but whatsoever he shall hear, that shall he speak, and he will show you things to come. He shall glorify me.",
            ref: "John 16:13",
        },
        {
            text: "When the day of Pentecost was fully come, they were all with one accord in one place: and suddenly there came a sound from heaven as of a rushing and mighty wind, and it filled all the house where they were sitting.",
            ref: "Acts 2:1",
        },
        {
            text: "Ye shall receive power, after that the Holy Ghost is come upon you: and ye shall be witnesses unto me both in Jerusalem, and in all Judea, and in Samaria, and unto the uttermost part of the earth.",
            ref: "Acts 1:8",
        },
        {
            text: "Because ye are sons, God hath sent forth the Spirit of his Son into your hearts, crying, Abba, Father.",
            ref: "Galatians 4:6",
        },
        {
            text: "The Spirit and the Bride say, Come. And let him that is athirst, come. And whosoever will, let him take the water of life freely.",
            ref: "Revelation 22:17",
        },
    ],
    trinity: [],
    annunciation: [
        {
            text: "Strength and honour are her clothing. She openeth her mouth with wisdom; and in her tongue is the law of kindness.",
            ref: "Proverbs 31:25-26",
        },
        {
            text: "The Angel Gabriel came unto Mary, and said, Hail thou that art highly favoured, the Lord is with thee. Blessed art thou among women.",
            ref: "Luke 1:28",
        },
        {
            text: "Mary said, My soul doth magnify the Lord, and my spirit hath rejoiced in God my Saviour. For he hath regarded the lowliness of his handmaiden. For behold, from henceforth all generations shall call me blessed.",
            ref: "Luke 1:46-48",
        },
        {
            text: "When Jesus saw his Mother, and the disiple standing by, whom he loved, he saith unto his Mother, Woman, behold thy son.",
            ref: "John 19:26",
        },
        {
            text: "When the fulness of time was come, God sent forth his Son made of a Woman, made under the Law, to redeem them that were under the Law, that we might receive the adoption of Sons.",
            ref: "Galations 4:4",
        },
        {
            text: "There appeared a great wonder in Heaven, a woman clothed with the sun, and the moon under her feet, and upon her head a crown of twelve stars.",
            ref: "Revelation 12:2",
        },
    ],
    saints: [
        {
            text: "The marriage of the Lamb is come, and his wife hath made herself ready. And to her was granted, that she should be arrayed in fine linen, clean and white: for the fine linen is the righteousness of the Saints.",
            ref: "Revelation 19:7-8",
        },
        {
            text: "He is Lord of lords, and King of kings, and they that are with him, are called, and chosen, and faithful.",
            ref: "Revelation 17:14",
        },
        {
            text: "The Lamb, which is in the midst of the throne, shall feed them, and shall lead them unto living fountains of waters: and God shall wipe away all tears from their eyes.",
            ref: "Revelation 6:17",
        },
        {
            text: "They shall hunger no more, neither thirst any more, neither shall the sun light on them, nor any heat.",
            ref: "Revelation 7:16",
        },
        {
            text: "They are before the throne of God, and serve him day and night in his temple: and he that sitteth on the throne shall dwell among them.",
            ref: "Revelation 7:15",
        },
        {
            text: "Behold, the Lord cometh with ten thousands of his Saints, to execute judgment upon all, and to convince all that are ungodly among them of all their ungodly deeds which they have committed.",
            ref: "Jude:14,15",
        },
        {
            text: "For our citizenship is in heaven; from whence also we look for the Saviour, the Lord Jesus Christ.",
            ref: "Philippians 3:20",
        },
        {
            text: "Give thanks to the Father, which hath made us meet to be partakers of the inheritance of the Saints in light.",
            ref: "Colossians 1:12",
        },
    ],
    ordinary: [
        {
            text: "Give thanks unto the LORD, call upon his Name, make known his deeds among the people. Let the heavens be glad, and let the earth rejoice: and let men say among the nations, The LORD reigneth.",
            ref: "1 Chronicles 16:8,31",
        },
        {
            text: "Ezra said, Thou, even thou art LORD alone, thou hast made Heaven, the Heaven of heavens, with all their host, the earth, and all things that are therein, the seas, and all that is therein, and thou preservest them all, and the host of Heaven worshippeth thee.",
            ref: "Nehemiah 9:6",
        },
        {
            text: "Let the words of my mouth, and the meditation of my heart, be alway acceptable in thy sight, O LORD, my strength and my redeemer.",
            ref: "Psalm 19:14",
        },
        {
            text: "LORD, I have loved the habitation of thy house, and the place where thine honour dwelleth.",
            ref: "Psalm 24:8",
        },
        {
            text: "O send out thy light and thy truth, that they may lead me, and bring me unto thy holy hill, and to thy dwelling.",
            ref: "Psalm 43:3",
        },
        {
            text: "The day is thine, O LORD, and the night is thine; thou hast prepared the light and the sun. Thou hast set all the borders of the earth; thou hast made summer and winter.",
            ref: "Psalm 74:17-18",
        },
        {
            text: "Lord, I have called daily upon thee; I have stretched forth my hands unto thee.",
            ref: "Psalm 88:9",
        },
        {
            text: "O worship the LORD in the beauty of holiness; let the whole earth stand in awe of him.",
            ref: "Psalm 96:9",
        },
        {
            text: "O magnify the LORD our God, and worship him upon his holy hill; for the LORD our God is holy.",
            ref: "Psalm 99:9",
        },
        {
            text: "I was glad when they said unto me, We will go into the house of the LORD.",
            ref: "Psalm 122:1",
        },
        {
            text: "Thus saith the high and lofty One that inhabiteth eternity, whose Name is Holy: I dwell in the high and holy place, with him also that is of a contrite and humble spirit, to revive the spirit of the humble, and to revive the heart of the contrite ones.",
            ref: "Isaiah 57:15",
        },
        {
            text: "Seek him that maketh the seven stars and Orion, and turneth the shadow of the earth in the morning, and maketh the day dark with night: that calleth for the waters of the sea, and poureth them out upon the face of the earth: the LORD is his Name.",
            ref: "Amos 5:8",
        },
        {
            text: "The LORD is in his holy temple: let all the earth keep silence before him.",
            ref: "Habakkuk 2:20",
        },
        {
            text: "Jesus said, All things are delivered to me of my Father: and no man knoweth who the Son is, but the Father: and who the Father is, but the Son, and he to whom the Son will reveal him.",
            ref: "Luke 10:22",
        },
        {
            text: "Jesus said, The hour cometh, and now is, when the true worshippers shall worship the Father in spirit and in truth: for the Father seeketh such to worship him.",
            ref: "John 4:23",
        },
        {
            text: "Jesus said, I am the light of the world: he that followeth me, shall not walk in darkness, but shall have the light of life.",
            ref: "John 8:12",
        },
        {
            text: "We know that all things work together for good, to them that love God, to them that are called according to his purpose.",
            ref: "Romans 8:28",
        },
        {
            text: "O the depth of the riches both of the wisdom and knowledge of God! How unsearchable are his judgments, and his ways are past finding out.",
            ref: "Romans 11:33",
        },
        {
            text: "I beseech you brethren, by the mercies of God, that ye present your bodies a living sacrifice, holy, acceptable unto God, which is your reasonable service.",
            ref: "Romans 12:1",
        },
        {
            text: "For ye are bought with a price; therefore glorify God in your body, and in your spirit, which are God's.",
            ref: "1 Corinthians 6:20",
        },
        {
            text: "The fruit of the Spirit is love, joy, peace, longsuffering, gentleness, goodness, faith, meekness, temperance: against such there is no law.",
            ref: "Galatians 5:22-23",
        },
        {
            text: "As the body without the spirit is dead, so faith without works is dead.",
            ref: "James 2:26",
        },
        {
            text: "Giving all diligence, add to your faith, virtue: and to virtue, knowledge; and to knowledge, temperance; and to temperance, patience; and to patience, godliness; and to godliness, brotherly kindness; and to brotherly kindness, charity.",
            ref: "2 Peter 1:5-7",
        },
        {
            text: "But ye beloved, building up your selves on your most holy faith, praying in the Holy Ghost, keep your selves in the love of God, looking for the mercy of our Lord Jesus Christ unto eternal life.",
            ref: "Jude:20-21",
        },
    ],
    morning: [],
    evening: [],
};
